import React from "react";
import { Link } from "react-router-dom";

import { Button, Container, Row, Col } from "reactstrap";
import WeaveTopBar from "../../../../components/WeaveTopBar/WeaveTopBar";
import BackButton from "../../../../components/BackButton";

import s from "./MarketRegisterPage.module.scss";
import PathHelper from "../../PathHelper";

export default function MarketRegisterPage() {
	return (
		<div className={s.welcome}>
			<WeaveTopBar />

			<Container fluid className={s.welcomePage}>
				<BackButton />

				<Row className={s.titleContainer}>
					<Col lg="12" sm="12">
						<div className="d-flex align-items-center justify-content-center">
							<p className={s.title}>establish public/private key pair</p>
						</div>

						<div className="d-flex align-items-center justify-content-center">
							<p className={s.description}>
								To establish an account on weavechain, a private and public key
								pair must be generated.
							</p>
						</div>
					</Col>
				</Row>

				<Row className={s.mediaContainer}>
					<Col lg="12" sm="12">
						<div className="d-flex align-items-center justify-content-center">
							<img
								src={require("../../../../assets/images/welcome/public-private-key.svg")}
								alt="..."
							/>
						</div>
					</Col>
				</Row>

				{/* Buttons */}
				<Row>
					<Col sm="12" className="d-flex justify-content-center">
						<Link to={PathHelper.getPath("market", "register/generate")}>
							<Button color="primary" className="btn-default">
								Generate for me
							</Button>
						</Link>
					</Col>
					<Col sm="12" className="d-flex justify-content-center">
						<Link to={PathHelper.getPath("market", "register/choose")}>
							<Button color="primary" className="btn-default btn-border">
								Upload my own key pair
							</Button>
						</Link>
					</Col>
				</Row>
			</Container>
		</div>
	);
}
